import { CommonModule } from '@angular/common';
import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';

export const GORM_IDENTITY_SETTINGS = new InjectionToken("GORM_IDENTITY_SETTINGS");
export interface IGormIdentitySettings { tokenUrl: string, matchUrls: string[] }

@NgModule({
	imports: [CommonModule]
})

export class GormIdentityModule {
	static forRoot(settings: IGormIdentitySettings): ModuleWithProviders<GormIdentityModule> {
		return {
			ngModule: GormIdentityModule,
			providers: [{
				provide: GORM_IDENTITY_SETTINGS,
				useValue: settings
			}]
		}
	}
}
